import { render } from "./EvaluationOfPatient.vue?vue&type=template&id=dc621e0a&scoped=true&ts=true"
import script from "./EvaluationOfPatient.vue?vue&type=script&lang=ts"
export * from "./EvaluationOfPatient.vue?vue&type=script&lang=ts"

import "./EvaluationOfPatient.vue?vue&type=style&index=0&id=dc621e0a&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc621e0a"]])

export default __exports__